import React, { Component } from 'react';
import { connect } from 'react-redux';

import ResponsesManager from '../questions/responsesManager'
import questionActions from '../../actions/questions';
import { hashToCollection, IncorrectSequencesInputAndConceptSelectorForm, } from '../../../Shared/index'

class EditIncorrectSequencesContainer extends Component {
  componentDidMount() {
    const { dispatch, generatedIncorrectSequences, match } = this.props;
    const { used } = generatedIncorrectSequences;
    const { params } = match;
    const { questionID } = params;
    if (!used[questionID]) {
      dispatch(questionActions.getUsedSequences(questionID))
    }
  }

  getIncorrectSequence = () => {
    const { match, questions, } = this.props;
    const { params } = match;
    const { incorrectSequenceID, questionID } = params;

    const { incorrectSequences, } = questions.data[questionID]
    const sequencesArray = Array.isArray(incorrectSequences) && incorrectSequences.every(is => is.key) ? incorrectSequences : hashToCollection(incorrectSequences)
    return sequencesArray.find(is => is.key === incorrectSequenceID);
  }

  submitForm = (data, incorrectSequenceID) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { questionID } = params;
    delete data.conceptResults.null;
    dispatch(questionActions.submitEditedIncorrectSequence(questionID, data, incorrectSequenceID));
    setTimeout(() => {window.history.back()}, 2000);
  };

  render() {
    const { generatedIncorrectSequences, match, questions, } = this.props;
    const { used } = generatedIncorrectSequences;
    const { params } = match;
    const { incorrectSequenceID, questionID } = params;
    return (
      <div>
        <IncorrectSequencesInputAndConceptSelectorForm
          fillInBlank
          item={Object.assign(this.getIncorrectSequence(), { id: incorrectSequenceID, })}
          itemLabel='Incorrect Sequence'
          onSubmit={this.submitForm}
          questionID={questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
          states
          usedSequences={used[questionID]}
        />
      </div>
    );
  }
}

function select(props) {
  return {
    questions: props.questions,
    generatedIncorrectSequences: props.generatedIncorrectSequences,
    fillInBlank: props.fillInBlank,
    states: props.states
  };
}

export default connect(select)(EditIncorrectSequencesContainer);
